import type { PrintSettings } from '../api/types';

export const STORAGE_KEYS = {
  templates: 'print_templates_v1',
  preferences: 'print_preferences_v1',
  contractTemplates: 'contract_templates_v1',
  /** 删除墓碑 id → 删除时间。没有它，别的设备的旧快照会把删掉的模板推回来。 */
  deletedTemplates: 'print_deleted_templates_v1',
} as const;

export const MAX_TEMPLATES_PER_TABLE = 20;
export const STORAGE_BUDGET_BYTES = 4 * 1024 * 1024;

export const DEFAULT_PRINT_SETTINGS: PrintSettings = {
  paperSize: 'A4',
  orientation: 'portrait',
  marginMm: 10,
  fontSizePx: 12,
  showIndex: true,
  title: '',
};

// 与模板库页面显示的「N/20」保持一致。以前代码里是 10，界面写 20，
// 用户建第 11 个时最旧的那个被静默删掉。
export const MAX_CONTRACT_TEMPLATES_PER_TABLE = 20;

export const DEFAULT_CONTRACT_SETTINGS = {
  paperSize: 'A4' as const,
  orientation: 'portrait' as const,
  marginMm: 15,
  baseFontSizePx: 12,
};

export const RANGE_LABELS = {
  visible: '视图可见',
  selected: '视图选中',
  all: '全表',
} as const;
